import { useQuery } from "react-query";
import { getCameraType1List } from "../../../../../actions/Utilities/CameraType1";

export default function useGetCameraType1List() {
  return useQuery("GetCameraType1", getCameraType1List, {
    refetchOnWindowFocus: false,
  });
}
